import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';

const $ = jQuery;

$(() => {
  // home landingpage
  $('.ce-hero-slider .swiper').each(function () {
    var t = $(this);
    var s = new Swiper(this, {
      modules: [Autoplay, EffectFade],
      loop: true,
      speed: 500,
      observer: true,
      observeParents: true,
      effect: 'fade',

      autoplay: {
        delay: 2000,
      },
    });
  });

  // project gallery
  const thumbs = $('.project-thumbnails figure');

  const gallery = new Swiper('.ce-project-gallery .swiper', {
    modules: [Autoplay],
    autoHeight: true,
    grabCursor: true,
    speed: 500,

    autoplay: {
      delay: 4000,
      disableOnInteraction: true, // Swipe/Drag stoppt Autoplay dauerhaft
    },

    on: {
      slideChange: function () {
        thumbs.removeClass('active');
        thumbs.eq(this.activeIndex).addClass('active');
      },
    },
  });

  // initial state
  thumbs.eq(0).addClass('active');

  // click handler
  thumbs.on('click', function (e) {
    e.preventDefault();

    gallery.autoplay.stop(); // Thumbnail-Klick zählt nicht als Swipe-Interaktion

    const index = thumbs.index(this);
    gallery.slideTo(index);
  });
});
